"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormCompleteRequestedMessage = void 0;
const base_html_1 = require("./base-html");
class FormCompleteRequestedMessage {
    get replyTo() {
        return this.manager.email;
    }
    constructor(vals) {
        Object.assign(this, vals);
    }
    get recipient() {
        return this.employee.email;
    }
    get title() {
        return `${this.manager.name} hat dich gebeten, ein Formular auszufüllen.`;
    }
    get text() {
        return `
Hallo ${this.employee.firstName},

${this.manager.name} hat dich gebeten, das Formular ${this.document.form.name} auszufüllen. Dies kannst du unter folgedem Link tun:

${this.url}

Liebe Grüße,
Dein Pentacode Team
`;
    }
    get html() {
        return (0, base_html_1.base)(`
            ${(0, base_html_1.paragraph)(`Hallo ${this.employee.firstName},`)}

            ${(0, base_html_1.paragraph)(`
                ${this.manager.name} hat dich gebeten, das Formular <strong>${this.document.form.name}</strong> auszufüllen.
            `)}

            ${(0, base_html_1.button)("Formular Ausfüllen", this.url)}

            ${(0, base_html_1.paragraph)(`
                Liebe Grüße,<br>
                Dein Pentacode Team
            `)}
        `);
    }
}
exports.FormCompleteRequestedMessage = FormCompleteRequestedMessage;
//# sourceMappingURL=form-complete-requested.js.map